import React from 'react';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useTranslate from '~/hooks/useTranslate';
import { goToNextStep } from '~/store/slices/updateApplication/updateApplication.slice';
import { Button, useWindowProperties } from '@qred/components-library';
import { useUpdateApplicationSelectors } from '~/store/selectors/updateApplication/updateApplication.selector';
import { StandardStepContentFooter } from '~/styles/BaseStyledComponents';
import { getNextStepButtonText } from '../utils/getButtonText.utils';

const NextStepButton = () => {
  const dispatch = useAppDispatch();

  const {
    currentStepIndex,
    pendingSteps,
    allSteps,
  } = useUpdateApplicationSelectors();
  const { isMobile } = useWindowProperties();
  const t = useTranslate();

  if (pendingSteps.length === 0) return null;

  const hasFinishedSteps = pendingSteps.length !== allSteps.length;
  const isFirstStep = currentStepIndex === -1;
  const showNextStepButton = allSteps.some(
    (s, i) => i > currentStepIndex && !s.finished
  );
  const buttonText = getNextStepButtonText({ hasFinishedSteps, isFirstStep });

  const handleClick = () => {
    if (showNextStepButton) dispatch(goToNextStep());
  };

  return showNextStepButton ? (
    <StandardStepContentFooter>
      <Button
        data-testid="update-application-next-button"
        onClick={handleClick}
        size="md"
        fullWidth={isMobile}
      >
        {t(buttonText)}
      </Button>
    </StandardStepContentFooter>
  ) : null;
};

export default NextStepButton;
